import * as z from 'zod';

import { Theme } from '#packages/web/theme';

export const themeSettingsSchema = z.object({
  /**
   * The name of the application theme.
   */
  name: z.enum(Theme.availableThemes).prefault('green'),

  /**
   * The appearance mode of the application.
   */
  appearance: z.enum(['light', 'dark', 'system']).prefault('system'),
});

export type ThemeSettings = z.infer<typeof themeSettingsSchema>;
export type ThemeName = ThemeSettings['name'];
export type ThemeAppearance = ThemeSettings['appearance'];
